function formatMoney(sum) {
  if (sum == null) {
    return "";
  }
  if (sum.class === String.class) {
    sum = parseFloat(sum);
  }
  return "$" + sum.toFixed(2);
}
function formatPercent(value) {
  if (value == null) {
    return "";
  }
  if (value.class === String.class) {
    value = parseFloat(value);
  }
  return (value * 100).toFixed(2) + "%";
}

/*
 * IMPORTANT: No Timezone Ajustments will be made
 * value: date as 'yyyy-mm-dd' string
 */
function formatDate(value) {
  if (value == null) {
    return "";
  }
  const dt = new Date(value);
  return dt.toLocaleString("en-US", {
    day: "numeric",
    year: "numeric",
    month: "short"
  });
}
export { formatDate, formatMoney, formatPercent };